import { useState } from 'react';
import { INITIAL_FORM_STATE } from './courseConstants';

export const useCourseForm = () => {
  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
  const [editingCourse, setEditingCourse] = useState(null);

  const handleNumeroSesionesChange = (value) => {
    const numSesiones = parseInt(value) || 0;
    const newSesiones = [];
    
    for (let i = 0; i < numSesiones; i++) {
      if (formData.sesiones[i]) {
        newSesiones.push(formData.sesiones[i]);
      } else {
        newSesiones.push({
          fecha_inicio: '',
          fecha_fin: '',
          hora_inicio: '',
          hora_fin: ''
        });
      }
    }
    
    setFormData({
      ...formData,
      numero_sesiones: value,
      sesiones: newSesiones
    });
  };

  const updateSesion = (index, field, value) => {
    const newSesiones = [...formData.sesiones];
    newSesiones[index] = { ...newSesiones[index], [field]: value };
    setFormData({ ...formData, sesiones: newSesiones });
  };

  const toggleReconocimiento = (reconocimientoId) => {
    const current = formData.reconocimiento || [];
    const newReconocimiento = current.includes(reconocimientoId)
      ? current.filter(r => r !== reconocimientoId)
      : [...current, reconocimientoId];
    setFormData({ ...formData, reconocimiento: newReconocimiento });
  };

  const resetForm = () => {
    setEditingCourse(null);
    setFormData(INITIAL_FORM_STATE);
  };

  const loadCourseData = (course) => {
    setEditingCourse(course);
    
    const numSesiones = parseInt(course.numero_sesiones) || 1;
    const sesiones = course.sesiones || [];
    
    if (sesiones.length === 0 && (course.fecha_inicio || course.hora_inicio)) {
      sesiones.push({
        fecha_inicio: course.fecha_inicio || '',
        fecha_fin: course.fecha_fin || course.fecha_inicio || '',
        hora_inicio: course.hora_inicio || '',
        hora_fin: course.hora_fin || ''
      });
    }
    
    while (sesiones.length < numSesiones) {
      sesiones.push({ fecha_inicio: '', fecha_fin: '', hora_inicio: '', hora_fin: '' });
    }
    
    setFormData({
      nombre: course.nombre,
      descripcion: course.descripcion || '',
      horas: course.horas,
      numero_sesiones: course.numero_sesiones || '',
      sesiones: sesiones,
      objetivos_generales: course.objetivos_generales || '',
      objetivos_especificos: course.objetivos_especificos || '',
      temario: course.temario || '',
      instructor_ids: course.instructor_ids || (course.instructor_id ? [course.instructor_id] : []),
      director_formacion_id: course.director_formacion_id || '',
      cliente: course.cliente || '',
      lugar_imparticion: course.lugar_imparticion || '',
      localidad: course.localidad || '',
      provincia: course.provincia || '',
      familia: course.familia || '',
      subfamilia: course.subfamilia || '',
      template_id: '',
      online_course_id: course.online_course_id || '',
      reconocimiento: course.reconocimiento || [],
      reconocimiento_otros: course.reconocimiento_otros || '',
      acreditacion_cfc: course.acreditacion_cfc || '',
      acreditacion_erc: course.acreditacion_erc || '',
      acreditacion_semes: course.acreditacion_semes || '',
      acreditacion_semicyuc: course.acreditacion_semicyuc || '',
      coste_total: course.coste_total || '',
      coste_por_alumno: course.coste_por_alumno || '',
      firma_director_url: course.firma_director_url || ''
    });
  };

  const handleTemplateSelect = (templateId, templates) => {
    const template = templates.find(t => t.id === templateId);
    if (template) {
      setFormData({
        ...formData,
        nombre: template.nombre,
        descripcion: template.descripcion || '',
        horas: template.horas,
        numero_sesiones: template.numero_sesiones || '',
        sesiones: [],
        objetivos_generales: template.objetivos_generales || '',
        objetivos_especificos: template.objetivos_especificos || '',
        temario: template.temario || '',
        familia: template.familia || '',
        subfamilia: template.subfamilia || '',
        template_id: templateId
      });
    }
  };

  const prepareDataForSubmit = () => {
    return {
      ...formData,
      horas: parseInt(formData.horas) || 0,
      numero_sesiones: formData.numero_sesiones ? parseInt(formData.numero_sesiones) : null,
      coste_total: formData.coste_total ? parseFloat(formData.coste_total) : null,
      coste_por_alumno: formData.coste_por_alumno ? parseFloat(formData.coste_por_alumno) : null,
      fecha_inicio: formData.sesiones[0]?.fecha_inicio || '',
      fecha_fin: formData.sesiones[formData.sesiones.length - 1]?.fecha_fin || formData.sesiones[0]?.fecha_inicio || '',
      hora_inicio: formData.sesiones[0]?.hora_inicio || '',
      hora_fin: formData.sesiones[0]?.hora_fin || ''
    };
  };

  return {
    formData,
    setFormData,
    editingCourse,
    handleNumeroSesionesChange,
    updateSesion,
    toggleReconocimiento,
    resetForm,
    loadCourseData,
    handleTemplateSelect,
    prepareDataForSubmit
  };
};
